// extracted by mini-css-extract-plugin
export var sliderRange = "_pf-2";
export var sliderRoot = "_pf-0";
export var sliderThumb = "_pf-3";
export var sliderTrack = "_pf-1";